import { render, staticRenderFns } from "./work-item-modal.component.vue?vue&type=template&id=5c284172&scoped=true&"
import script from "./work-item-modal.component.vue?vue&type=script&lang=ts&"
export * from "./work-item-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./work-item-modal.component.vue?vue&type=style&index=0&id=5c284172&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c284172",
  null
  
)

export default component.exports